import axios from 'axios';

export const fetchProvinces = async (search = '') => {
    try {
        const options = {
            withCredentials: true,
            method: 'GET',
            url: `${process.env.REACT_APP_BASE_SERVER}/provinces`,
            params: {}
        };
        if (search) {
            options.params.search = search;
        }

        const response = await axios(options);

        if (response.data.success && Array.isArray(response.data.data)) {
            return response.data.data.map(i => ({
                id: i.code,
                label: i.name,
                search: `${i.name}`
            }));
        }

        return [];
    } catch (error) {
        console.error('Error fetching provinces:', error);
        return [];
    }
};

export const fetchCities = async (provinceCode, search = '') => {
    try {
        const options = {
            withCredentials: true,
            method: 'GET',
            url: `${process.env.REACT_APP_BASE_SERVER}/cities`,
            params: {}
        };
        if (search) {
            options.params.search = search;
        }
        if (provinceCode) {
            options.params.provinceCode = provinceCode;
        }

        const response = await axios(options);

        if (response.data.success && Array.isArray(response.data.data)) {
            return response.data.data.map(i => ({
                id: i.code,
                label: i.name,
                search: `${i.name}`
            }));
        }

        return [];
    } catch (error) {
        console.error('Error fetching cities:', error);
        return [];
    }
};
